import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BotbuttonPage } from './botbutton.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'botbutton',
        component: BotbuttonPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [BotbuttonPage],
    exports: [BotbuttonPage]
})
export class BotbuttonPageModule {}
